module.exports = __webpack_public_path__ + "img/thumbnail_EuropeanBadger_f_normal.67fba4ba.png";